import SignIn from "../Pages/Auth/SignIn";
import Register from "../Pages/Auth/Register";
import VisualLogin2 from "../Components/Pages/Others/Authentication/VisualLogin2";
export const authRoutes = [
  //authentication
  // { path: `${process.env.PUBLIC_URL}/login`, element: <Register /> },
  // { path: `${process.env.PUBLIC_URL}/login2`, element: <VisualLogin2 /> },
  // { path: `${process.env.PUBLIC_URL}/sign_up`, element: <Register /> },
];
